import { Drawer, Layout } from 'antd';
import React, { useState } from 'react';
import cn from 'classnames';
import AppFooter from './AppFooter/AppFooter';
import { BlockNavigation } from './AppHeader/AppHeader.types';
import styles from './AppLayout.module.scss';
import Sidebar from 'Components/Sidebar';
import { useIsMobile } from 'Hooks';
import SidebarHeader from 'Components/Sidebar/components/SidebarHeader';

interface AppLayoutProps extends BlockNavigation {
	className?: string;
	header?: React.ReactNode;
	headerTheme?: 'light';
	contentAddon?: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({
	className,
	children
}) => {
	const [showDrawer, setShowDrawer] = useState(false);
	const isMobile = useIsMobile();

	const closeDrawer = () => setShowDrawer(false);

	return (
		<Layout className={cn(styles.root, className)}>
			{isMobile ? 
				<SidebarHeader {...{ showDrawer, openDrawer: () => setShowDrawer(true) }} /> :
				<Layout.Sider>
					<Sidebar isDrawer={false} closeDrawer={closeDrawer} />
				</Layout.Sider>}
			<Layout.Content>
				<>
					{children}
					<AppFooter />
				</>
			</Layout.Content>

			{isMobile && <Drawer
				placement="left"
				visible={showDrawer}
				onClose={closeDrawer}
				width={280}
				height="100vh">
				<Sidebar isDrawer={true} closeDrawer={closeDrawer}  />
			</Drawer>}
		</Layout>
	);
};

export default AppLayout;
